
import { A2AAgent } from '../../types';

// Status-specific agent mapping
const STATUS_AGENT_MAP: Record<string, Partial<A2AAgent>> = {
  'new': {
    id: 'screening-agent',
    name: 'Screening Agent',
    capabilities: ['candidate-screening', 'initial-assessment']
  },
  'contacted': {
    id: 'communication-agent', 
    name: 'Communication Agent',
    capabilities: ['scheduling', 'follow-up']
  },
  'interview': {
    id: 'interview-agent',
    name: 'Interview Agent', 
    capabilities: ['interview-coordination', 'assessment']
  },
  'offer': {
    id: 'offer-agent',
    name: 'Offer Agent',
    capabilities: ['offer-management', 'negotiation']
  },
  'hired': {
    id: 'onboarding-agent',
    name: 'Onboarding Agent',
    capabilities: ['onboarding', 'documentation']
  },
  'rejected': {
    id: 'feedback-agent',
    name: 'Feedback Agent',
    capabilities: ['feedback-collection', 'relationship-management']
  }
};

export function getA2AAgentForStatus(status: string): Partial<A2AAgent> | undefined {
  return STATUS_AGENT_MAP[status];
}
